import React from 'react'
import classNames from 'classnames'
import style from '../scss/components/Quote.module.scss'
// @ts-ignore
import { Fade } from "react-awesome-reveal"

type Props = {
    title: string
    children: any
    big: boolean
    hasMaxWidth: boolean
    animated?: boolean

}

const Quote = (props: Props) => {
    const view = (
        <div className={classNames(style.Wrapper, {
            [style.Max315]: props.hasMaxWidth,
            [style.Big]: props.big,
        })}>
            <div className={classNames(style.Title, {
                [style.Big]: props.big,
            })}>
                {props.title}
            </div>
            <div className={classNames(style.Description, {
                [style.Big]: props.big,
            })}>
                {props.children}
            </div>
        </div>
    )


    if (props.animated)
        return (
            <Fade>
                {view}
            </Fade>
        )
    else
        return view
}

Quote.defaultProps = {
    big: false,
    hasMaxWidth: false,
    animated: true,
}

export default Quote
